var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerIndicator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "47px",
    viewBox: "0 0 31 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 4.5,
    cy: 4.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-183.3%",
    y: "-183.3%",
    width: "466.7%",
    height: "466.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.288655698   0 0 0 0 0.56455189   0 0 0 0 0.886238694  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Power-Indicator",
    transform: "translate(11.000000, 11.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4A90E2",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-6.22154025,26.5058594 L-6.22154025,22.0908203 L-2.65611056,22.0908203 L-2.65611056,24.8037109 L-5.20786837,24.8037109 L-5.20786837,26.5058594 L-6.22154025,26.5058594 Z M-3.66978244,23.1044922 L-5.20786837,23.1044922 L-5.20786837,23.7929688 L-3.66978244,23.7929688 L-3.66978244,23.1044922 Z M-1.88116634,26.5058594 L-1.88116634,22.0908203 L1.68426335,22.0908203 L1.68426335,26.5058594 L-1.88116634,26.5058594 Z M0.670591475,23.1044922 L-0.867494462,23.1044922 L-0.864564775,25.4921875 L0.670591475,25.4921875 L0.670591475,23.1044922 Z M2.44748883,26.5117188 L2.44748883,22.0908203 L3.4611607,22.0908203 L3.4611607,25.4980469 L4.14963726,25.4980469 L4.14963726,22.0908203 L5.16623883,22.0908203 L5.16623883,25.4980469 L5.85471539,25.4980469 L5.85471539,22.0908203 L6.86838726,22.0908203 L6.86838726,26.5117188 L2.44748883,26.5117188 Z M7.65212055,26.5058594 L7.65212055,22.0908203 L11.2175502,22.0908203 L11.2175502,23.1044922 L8.66579243,23.1044922 L8.66579243,23.7929688 L10.3679409,23.7929688 L10.3679409,24.8037109 L8.70680805,24.8037109 L8.70094868,25.4921875 L11.2175502,25.4921875 L11.2175502,26.5058594 L7.65212055,26.5058594 Z M11.9866351,26.5058594 L11.9866351,22.0908203 L15.5520648,22.0908203 L15.5520648,24.8037109 L14.4592913,24.8037109 L15.5520648,25.8994141 L15.5520648,26.5058594 L14.5383929,26.5058594 L13.000307,24.9560547 L13.000307,26.5058594 L11.9866351,26.5058594 Z M14.5383929,23.1044922 L13.000307,23.1044922 L13.000307,23.7929688 L14.5383929,23.7929688 L14.5383929,23.1044922 Z",
    id: "POWER",
    fill: "#FFFFFF",
    transform: "translate(4.665262, 24.301270) rotate(-90.000000) translate(-4.665262, -24.301270) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 5,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 6.5,
    cy: 3.5,
    r: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIndicator);
export default __webpack_public_path__ + "static/media/power-indicator.6979e1c44b270e4d66676fb870a3573f.svg";
export { ForwardRef as ReactComponent };